import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import 'rxjs/add/observable/of';
import { environment } from '../../environments/environment';
var AddressBookService = /** @class */ (function () {
    function AddressBookService(http, localSt) {
        this.http = http;
        this.localSt = localSt;
        this.serverUrl = environment.serverUrl;
    }
    AddressBookService.prototype.addressBookList = function () {
        var reqEndPoint = 'addressbook';
        return this.http.get(this.serverUrl + reqEndPoint);
    };
    AddressBookService.prototype.addressBookMakeDefault = function (addressId) {
        var reqEndPoint = 'addressbook/default';
        return this.http.post(this.serverUrl + reqEndPoint, { id: addressId });
    };
    AddressBookService.prototype.addNewAddress = function (data) {
        var reqEndPoint = 'addressbook';
        return this.http.post(this.serverUrl + reqEndPoint, data);
    };
    AddressBookService.prototype.getEditAddress = function (addressId) {
        var params = 'addressbook/' + addressId;
        return this.http.get(this.serverUrl + params);
    };
    AddressBookService.prototype.updateAddress = function (data) {
        var params = 'addressbook';
        return this.http.put(this.serverUrl + params, data);
    };
    AddressBookService.prototype.zipCodeListing = function (data) {
        var params = 'zipcodes/active?';
        if (data.page) {
            params += "page=" + data.page;
        }
        if (data.limit) {
            params += "&limit=" + data.limit;
        }
        if (data.search) {
            params += "&search=" + data.search;
        }
        return this.http.get(this.serverUrl + params);
    };
    AddressBookService.prototype.activeZipCodeListing = function () {
        var params = 'zipcodes/active/all';
        return this.http.get(this.serverUrl + params);
    };
    AddressBookService.prototype.deleteAddress = function (addressId) {
        return this.http.request('delete', this.serverUrl + 'addressbook', { body: { id: addressId } });
    };
    return AddressBookService;
}());
export { AddressBookService };



// WEBPACK FOOTER //
// ./src/app/services/address.service.ts.pre-build-optimizer.js